import React, { useContext } from "react"

import { last } from "shared/lib/arrayUtils"

import { ItemsContext } from "./ItemsContext"
import { TableContext } from "./TableContext"
import { TableItem } from "./TableItem"
import { LastIndexDroppable } from "./dn-d/LastIndexDroppable"
import { DragMoveContext } from "./dn-d/TableDnDContext"

type RowComponentProps = { index: number; style: React.CSSProperties }

export const VirtualizedRowRendererInner = React.memo(
  ({ index, style }: RowComponentProps) => {
    const items = useContext(ItemsContext)
    const { rowHeight } = useContext(TableContext)
    const { nextIndex } = useContext(DragMoveContext)
    const item = items[index]

    if (index === items.length) {
      return (
        <div key="last" style={style}>
          <LastIndexDroppable index={index} height={rowHeight} />
        </div>
      )
    }

    return (
      <TableItem
        key={item.id}
        style={style}
        item={item}
        index={index}
        parentID={item.parents.length > 0 ? last(item.parents) : null}
        insertBefore={index === 0 && nextIndex === index}
        insertAfter={nextIndex === index + 1}
      />
    )
  }
)

// eslint-disable-next-line react/function-component-definition
export const VirtualizedRowRenderer = (props: RowComponentProps) => (
  <VirtualizedRowRendererInner {...props} />
)
